import React from 'react';
import moment from 'moment';
import { makeStyles, withStyles, Table, Divider } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  depositContext: {
    flex: 1,
  },
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  header: {
    fontSize: 12,
    fontWeight: 600
  },
  content: {
    fontSize: 12,
  },
  circularProgressbar: {
    maxWidth: 120
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
  }
}));

const StyledDivider = withStyles({
  root: {
    background: '#DCDCDC',
    height: 2,
  },
})(Divider);

export default function RecentLeave({ rows }) {
  const classes = useStyles();
  const [showCompetent, setShowCompetent] = React.useState(false);
  const convertDateFormatted = (date) => {
    if (date === '' || date === null) {
      return null
    } else {
      return moment(date).format(window.global.displayFormat);
    }
  }

  React.useEffect(() => {
    if (rows !== undefined) {
      setShowCompetent(true)
    }
  }, [rows]);

  return (
    <React.Fragment>
      {showCompetent ?
        <div className={classes.root}>
          <Title>
            <FormattedMessage
              id="recent_leave.title"
            />
          </Title>
          <StyledDivider />
          <TableContainer>
            <Table size="small" aria-label="recent-leaves-table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.header}>
                    <FormattedMessage
                      id="new_application.leave_type"
                    />
                  </TableCell>
                  <TableCell className={classes.header} align="left">
                    <FormattedMessage
                      id="common.from"
                    />
                  </TableCell>
                  <TableCell className={classes.header} align="left">
                    <FormattedMessage
                      id="common.to"
                    />
                  </TableCell>
                  <TableCell className={classes.header} align="left">
                    <FormattedMessage
                      id="new_application.taken"
                    />
                  </TableCell>
                  <TableCell className={classes.header} align="left">
                    <FormattedMessage
                      id="table.status"
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={row.id || i}>
                    <TableCell component="th" scope="row">
                      {row.type}
                    </TableCell>
                    <TableCell align="left" className={classes.content}>{convertDateFormatted(row.startDate)} {row.startTime} </TableCell>
                    <TableCell align="left" className={classes.content}>{convertDateFormatted(row.untilDate)} {row.endTime} </TableCell>
                    <TableCell align="left" className={classes.content}>{row.period} </TableCell>
                    <TableCell align="left" className={classes.content}>{row.status} </TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        :
        <div className={classes.circularProgress}>
          <CircularProgress />
        </div>
      }
    </React.Fragment>
  );
}